<div class="form-block" *ngIf="!disableRecipientSelection">
    <form [formGroup]="addRecipientForm">
        <div fxLayout="row" fxLayoutGap="10px" fxLayout.lt-md="column" >
            <div fxFlex="30" fxFlex.lt-md="100">
                <static-dictionary-select-ctrl [settings]="{fxFill:true}"
                    [caption]="'claims-center.claimMessages.recipientRole'" [formControlName]="'recipientRole'"
                    [staticDictionaryName]="'recipientRole'" [orderById]="true" [allowedValuesLimitation]="allowedRecipientRoles"
                    (valueChangeEvent)="recipientRoleChanged($event)"></static-dictionary-select-ctrl>
            </div>

            <!-- meritoric employee and technician employee and workshop users -->
            <div *ngIf="addRecipientForm.controls.recipientRole.value === 1 || addRecipientForm.controls.recipientRole.value === 2 
            || addRecipientForm.controls.recipientRole.value === 7 || addRecipientForm.controls.recipientRole.value === 6  
            || addRecipientForm.controls.recipientRole.value === 17 || addRecipientForm.controls.recipientRole.value === 18"
                fxFlex="40" fxFlex.lt-md="100" fxLayoutAlign="center center" >
                <div *ngIf="contactRecipientHasData" >
                    <div fxLayout="column" >
                        <span>{{addRecipientForm.controls.recipientInfo.value }}</span>
                    </div>
                </div>
                <div *ngIf="!contactRecipientHasData && !loadingRecipientData" >
                    <span>{{'claims-center.claimMessages.noSelectedSubjectInClaim' | translate}}</span>
                </div>
            </div>

            <!-- other employee -->
            <div *ngIf="addRecipientForm.controls.recipientRole.value === 4"  fxFlex="40" fxFlex.lt-md="100">
                <app-user-select-ctrl [caption]="'claims-center.claimMessages.otherEmployeeAsRecipient'" [settings]="{fxFill:true}"
                [formControlName]="'portalUserId'" (valueChangeEvent)="otherUserSelectionChanged($event)"></app-user-select-ctrl>
            </div>

            <!-- add recipient button and need confirmation check -->
            <div fxLayoutGap="5" fxLayout="column" *ngIf="contactRecipientHasData && !loadingRecipientData" fxFlex="30" fxFlex.lt-md="100">
                <button kendoButton [primary]="true"
                    (click)="addRecipient()">{{'claims-center.claimMessages.addRecipient' | translate}}</button>
                <checkbox-input-ctrl [caption]="'claims-center.claimMessages.isReadConfirmationRequired'"
                    [formControlName]="'isReadConfirmationRequired'">
                  </checkbox-input-ctrl>
            </div>


            <div *ngIf="!contactRecipientHasData && addRecipientForm.controls.recipientRole.value > 0 && !loadingRecipientData;"
                class="error-label" fxFlex="30" fxFlex.lt-md="100" fxLayoutAlign="center center">
                {{'claims-center.claimMessages.noRecipientData' | translate}}
            </div>

            <app-loading-panel [isLoading]="loadingRecipientData"></app-loading-panel>

        </div>

         <!-- display info about not enabled user-->
         <div fxLayoutGap="5" fxLayout="column" *ngIf="contactRecipientHasData && !loadingRecipientData 
         && addRecipientForm.controls.isDisabledPortalUser.value">
             <h4 class="error-label">{{'claims-center.claimMessages.userAssociatedWithRecipientIsInactive' | translate}}</h4>
             </div>

    </form>
</div>

<div class="form-block">
    <form [formGroup]="composeMessageForm">
        <div fxLayout="column" fxLayoutGap="10px">

            <div fxLayout="column">
                <div>
                    <strong *ngIf="!composeMessageForm.controls.recipients.value?.length">
                        {{'claims-center.claimMessages.noRecipients' | translate}}</strong>
                        
                    <strong *ngIf="composeMessageForm.controls.recipients.value?.length">
                            {{'claims-center.claimMessages.to' | translate}}</strong>
                </div>

                <div class="recipient-line" *ngFor="let recipient of composeMessageForm.controls.recipients.value"
                    fxLayoutGap="5px">
                    <kendo-icon *ngIf="!disableRecipientSelection" [name]="'delete'" (click)="removeRecipient(recipient)"></kendo-icon>
                    <span>{{recipient.recipientRole | staticDictionaryCaption:'recipientRole' |async }}
                        - <strong>{{recipient.recipientInfo}}</strong></span>
                        <img *ngIf="recipient.isReadConfirmationRequired" src="./assets/img/read_confirmation.png" [width]="32"
                        title="{{'claims-center.claimMessages.isReadConfirmationRequired' | translate}}" alt="isReadConfirmationRequired" />

                </div>
            </div>

            <div fxFill fxLayout="row" fxLayoutGap="10">
                <div fxFlex="95">
                    <text-input-ctrl [caption]="'claims-center.claimMessages.title'" [formControlName]="'title'"
                        [settings]="{fxFill:true}">
                    </text-input-ctrl>
                </div>
                <div fxFlex="5" fxLayoutAlign="center end" *ngIf="!disableTemplates">
                    <button type="button" kendoButton (click)="chooseTemplate()" icon="search"> </button>
                </div>
            </div>

            <textarea-input-ctrl [caption]="'claims-center.claimMessages.contentText'" [formControlName]="'contentText'"
                [settings]="{fxFill:true,rows:10}"></textarea-input-ctrl>

            <checkbox-input-ctrl [caption]="'claims-center.claimMessages.isPriority'" [formControlName]="'isPriority'">
            </checkbox-input-ctrl>

        </div>
    </form>
</div>
<kendo-dialog-actions>
    <button kendoButton [primary]="true" (click)="send()">{{'claims-center.claimMessages.sendMessage' |
        translate}}</button>
</kendo-dialog-actions>

<div kendoDialogContainer #composePortalMessageDialog></div>